export interface PriceCalculator {
  originalPrice: number;
  basePrice: number;
  plays: number;
  price: number;
  addOnPrice?: number;
  originalAddOnPrice?: number;
}

export default function calculatePrice({
  discount,
  stats,
  variety,
}: {
  discount: number;
  stats: API.MembershipProductStats;
  variety: API.MembershipProductOffer;
  // relatedProducts?: API.MembershipProduct[];
}): PriceCalculator {
  const plays =
    variety.auto && variety.plays - stats.played > 0 ? variety.plays - stats.played : variety.plays;
  const startPrice = variety.price || 0;
  const originalPrice = Math.ceil(
    variety.auto ? (((startPrice * 100) / variety.plays) * plays) / 100 : startPrice,
  );
  let addOnPrice = 0;
  if (variety?.addOn?.price) {
    addOnPrice = Math.ceil(variety?.addOn?.price * (1 - discount) || 0);
  }
  const originalAddOnPrice = variety?.addOn?.price || 0;
  let price = Math.ceil(originalPrice * (1 - discount));

  const basePrice = price;

  // @todo need to look up all products and check if it has auto on the main item
  // We should probably split this off into something on the API and let it get cached
  if (variety.combos) {
    for (const combo of variety.combos) {
      price += Math.ceil((combo.price || 0) * (1 - discount));
    }
  }

  if (variety.addOn) {
    price += Math.ceil((variety.addOn.price || 0) * (1 - discount));
  }

  return { originalPrice, basePrice, addOnPrice, originalAddOnPrice, plays, price };
}
